import React from "react";
import { matchPath, NavLink, useLocation } from "react-router-dom";

import routes from "../routes";

import { CBreadcrumb, CBreadcrumbItem } from "@coreui/react";
import { useSelector } from "react-redux";
import { userSelector } from "../features/userSlice";

const AppBreadcrumb = () => {
  const currentLocation = useLocation().pathname;
  const { user, selectedAccount } = useSelector(userSelector);

  const currentAccount =
    selectedAccount === user._id
      ? user
      : user.accounts.find((account) => account._id === selectedAccount);

  const getRouteName = (pathname, routes) => {
    const currentRoute = routes.find((route) => {
      if (
        matchPath(
          {
            path: route.path,
            exact: true,
            strict: false,
          },
          pathname
        )
      ) {
        return true;
      }

      return false;
    });

    return currentRoute ? currentRoute.name : false;
  };

  const getBreadcrumbs = (location) => {
    const breadcrumbs = [];
    location.split("/").reduce((prev, curr, index, array) => {
      const currentPathname = `${prev}/${curr}`;
      const routeName = getRouteName(currentPathname, routes);
      routeName &&
        breadcrumbs.push({
          pathname: currentPathname,
          name: routeName,
          active: index + 1 === array.length ? true : false,
        });
      return currentPathname;
    });
    return breadcrumbs;
  };

  const breadcrumbs = getBreadcrumbs(currentLocation);

  return (
    <CBreadcrumb className="m-0 ms-2">
      <li className="breadcrumb-item">{currentAccount.twitch.displayName}</li>
      {breadcrumbs.map((breadcrumb, index) => {
        if (breadcrumb.active) {
          return (
            <li className="breadcrumb-item" key={index}>
              {breadcrumb.name}
            </li>
          );
        }
        return (
          <li className="breadcrumb-item" key={index}>
            <NavLink
              to={breadcrumb.pathname}
              style={{ textDecoration: "none" }}
              color="primary"
            >
              {breadcrumb.name}
            </NavLink>
          </li>
        );
      })}
    </CBreadcrumb>
  );
};

export default React.memo(AppBreadcrumb);
